
import { DandDAPIClass } from "@utilities/smart_api_class";

const DandDAPI = (function() {
  let instance: DandDAPIClass;

  function createInstance() {
    const api = new DandDAPIClass();
    return api;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();


export default DandDAPI;